@let cp = content();
@if (cp) {
  <div class="track-info">
    <div class="played-at-time">
      @if (startedAt()) {
        {{ startedAtFormatted() }}
      }
    </div>
    <div class="metadata-wrapper">
      <div class="title-and-performer">
        <div class="track-name">{{ trackName() }}</div>
        @if (cp.performerName) {
          <div class="divider">-by-</div>
          <div class="performer-name">{{ cp.performerName }}</div>
        }
      </div>
      <div class="release-name">{{ cp.releaseName }}</div>
      <div class="label">
        {{ trackLabel() }}
      </div>
    </div>
  </div>
}
